export default __webpack_public_path__ + "static/media/mario4.c978d807.jpg";